import GlossaryNav from './GlossaryNav';

export default GlossaryNav;
